import { useQuery } from "@tanstack/react-query";
import { matrizApi } from "./axios";
import {
    ValidateCurrentToken,
    LogoutSystem, 
} from '../../helpers';

const getMatriz = async (urlConcat:string | null) => {
    const validateToken = ValidateCurrentToken();

    if(!validateToken) return [];

    if(urlConcat){
        const { data } = await matrizApi.get(urlConcat,{ headers: { 'Authorization': validateToken }});
        return data;
    }

    const { data } = await matrizApi.get('');
    return data;

    
}

export const useMatriz = (urlConcat:string | null)=>{

    const matrizQuery = useQuery(
        ["matriz"],
        ()=>getMatriz(urlConcat),
        {
            refetchOnWindowFocus:false
        }
    );


    return {
        matrizQuery
    };
}